import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { Atividade } from 'src/app/core/atividade';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { Programa } from 'src/app/core/programa';
import { Projeto } from 'src/app/core/projeto';
import { TiposAtividades } from 'src/app/core/tipos-atividades';
import { Unidade } from 'src/app/core/unidade';
import { AtividadeService } from 'src/app/services/atividade/atividade.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'cadastrar-oficina',
  templateUrl: './cadastrar-oficina.component.html',
  styleUrls: ['./cadastrar-oficina.component.css']
})
export class CadastrarOficinaComponent implements OnInit {

  oficina: Atividade = new Atividade();


  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  mostrarBotaoCadastrar = true;
  mostrarBotaoAtualizar = true;

  isAtualizar = false;
  area: string;
  menu: string;
  constructor(
    private atividadeService: AtividadeService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastService: ToastService) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
    this.area = this.getArea();
    this.limpar();

    if (!this.perfilAcesso.insere) {
      this.mostrarBotaoCadastrar = false;
    }

    if (!this.perfilAcesso.altera) {
      this.mostrarBotaoAtualizar = false;
    }

    const id = this.activatedRoute.snapshot.queryParams.id ? this.activatedRoute.snapshot.queryParams.id : null;
    if (id) {
      this.isAtualizar = true;
      this.atividadeService.getById(id).subscribe((oficina: Atividade) => {
        this.oficina = oficina;
      });
    }
    
  }

  getMenu(): string {
    const primeiroSegmento = this.router.url.split('/')[1];
    return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
  }

  private getArea(): string {
    this.menu = this.getMenu();
    return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
  }

  mostrarBotaoLimpar() {
    if (this.isAtualizar) { return false; }
    if (!this.mostrarBotaoAtualizar) { return false; }
    if (!this.mostrarBotaoCadastrar) { return false; }

    return true;
  }


  cadastrar() {

    if (!this.oficina.tiposAtividades || !this.oficina.tiposAtividades.id) {
      this.toastService.showAlerta('Selecione um tipo de atividade.');
      return;
    }
      
    this.atividadeService.cadastrar(this.oficina).subscribe(() => {
      const rota = this.menu ? this.menu+'/oficinas':'oficinas';
      this.router.navigate([rota]);
      this.toastService.showSucesso('Oficina cadastrada com sucesso!');
    });
  }

  limpar() {
    this.oficina = new Atividade();
    this.oficina.projeto = new Projeto();
    this.oficina.programa = new Programa();
    this.oficina.unidade = new Unidade();
    this.oficina.tiposAtividades = new TiposAtividades();
    this.oficina.acoes = [];
    this.oficina.area = this.area;
  }

  cancelar() {
    const rota = this.menu ? this.menu+'/oficinas':'oficinas';
    this.router.navigate([rota]);
  }


  atualizar() {

    if (!this.oficina.tiposAtividades || !this.oficina.tiposAtividades.id) {
      this.toastService.showAlerta('Selecione um tipo de atividade.');
      return;
    }

    this.atividadeService.alterar(this.oficina).subscribe(() => {
      const rota = this.menu ? this.menu+'/oficinas':'oficinas';
      this.router.navigate([rota]);
      this.toastService.showSucesso('Oficina atualizada com sucesso.');
    });

  }


}
